<template>
  <div v-if="isAdmin" class="playground panel-admin-body">
    <!--   <winners survey-code="eCsy84LtjCTMUzZQXowZ9ykC2MDpT4cb"/> -->
    <div class="title">
      <div class="d-flex">
        {{ title }}
      </div>
    </div>
    <h4 class="pt-2 text-primary">Survey Quality Score</h4>
    <survey-quality-score
      :input-survey-code="inputSurveyCode"    
    />

<!--
    <div>
      <h4 class="text-primary">Survey Taker Post Message</h4>
    </div>    
    <benchmark-exclusion 
      :input-client-code="inputClientCode"    
    />
-->        
    <div class="pt-5">
      <h4 class="text-primary">Benchmark Mapping</h4>
      <button type="submit" class="btn btn-primary mt-5" @click="buildBenchmarkMapping()">
            <span>Build Benchmark Mapping</span>
      </button>
    </div>    

    <div class="d-none">
      <h4 class="text-primary">Print Report</h4>
      <button type="submit" class="btn btn-primary mt-5" @click="executePrintReportToPPTX()">
            <span>Download Power Point</span>
      </button>
    </div>    

<!--
  https://www.codeandweb.com/babeledit/tutorials/how-to-translate-your-vue2-app-with-vue-i18n
-->    
<!--    

    <button type="submit" class="d-none btn btn-primary mt-5" @click="processDefaultWinnerMaps()">
          <span>Process Default Winner's Map</span>
    </button>
   <dashboard-welcome-slider/>
   <print-report-template :title="title" :sub-title="subTitle" />
-->   
  </div>
  <div v-else class="panel-admin-body no-permission-list">You do not have permission to view this page</div>
</template>
<script>
//import Winners from "../components/chart/Winners.vue";
import PrintReportTemplate from "./print-report/PrintReportTemplate.vue";
//import DashboardWelcomeSlider from "../components/dashboard/DashboardWelcomeSlider.vue";
import DataTableMixins from "../mixins/DataTableMixins.vue";

import ViewMixins from "../mixins/ViewMixins.vue";
import AdminMixins from "../mixins/AdminMixins.vue";
import AdminService from "../services/admin.service";
import WinnersService from "../services/chart/winners.service";
import ClientService from "../services/client.service";
import SurveyService from "../services/survey.service";
import PowerPointService from "../services/power.point.service";
import ReportService from "../services/report.service";
import BenchmarkCompanyService from "../services/benchmark.company.service";
import pptxgen from "pptxgenjs";
import BenchmarkExclusion from "../components/BenchmarkExclusion.vue";
import SurveyQualityScore from "../components/SurveyQualityScore.vue";
import benchmarkCompanyService from '../services/benchmark.company.service';

export default {
  name: "Playground",
  mixins: [AdminMixins, ViewMixins, DataTableMixins],
  components: {SurveyQualityScore},
  props: {},
  data() {
    return {
      title: "At the Playground",
      subTitle: "At the Playground",
      saveReport: false,
      printReportUrl: "",
      inputSurveyCode: SurveyService.getSurveyCode(),
      inputClientCode: ClientService.getClientCode(),
      reportGenerationModalContent: "",
      clientReport:
      {
  "clientId": 38175,
  "title": "Test",
  "subTitle": "Test 123",
  "includeCoverPage": "N",
  "includeEndPage": "N",
  "includeContentPage": "N",
  "clientChartReportPages": [
    {
      "clientChartId": 1217,
      "name": "Predictive Analytics",
      "sequenceNumber": 1,
      "include": false
    },
    {
      "clientChartId": 1217,
      "name": "Metric Trends",
      "sequenceNumber": 2,
      "include": false
    },
    {
      "clientChartId": 1217,
      "name": "Profile Trends",
      "sequenceNumber": 3,
      "include": false
    },
    {
      "clientChartId": 1217,
      "name": "Contribution",
      "sequenceNumber": 4,
      "include": true
    }
  ],
  "clientReportId": 0
}
/*      
clientReport:

{
  "id": 0,
  "clientReportId": 0,
  "clientId": 37510,
  "title": "20",
  "subTitle": "apr-1",
  "filePath": "20-apr-1.pptx",
  "includeCoverPage": "N",
  "includeContentPage": "N",
  "includeEndPage": "N",
  "pin": "N",
  "clientName": "Aramark HE",
  "clientChartReportPages": [
    {
      "clientChartId": 1438,
      "name": "Predictive Analytics",
      "include": true
    },
    {
      "clientChartId": 1438,
      "name": "Metric Trends",
      "include": true
    },
    {
      "clientChartId": 1438,
      "name": "Profile Trends",
      "include": true
    },
    {
      "clientChartId": 1438,
      "name": "Pricing Power",
      "include": true
    },
    {
      "clientChartId": 1438,
      "name": "Metric Contribution",
      "include": true
    }
  ],
  "savedClientChartReportPages": []
}

*/


/*
// Report for predictive Analytics Table
{
  "id": 0,
  "clientReportId": 0,
  "clientId": 37909,
  "title": "Print Report Test",
  "subTitle": "12",
  "filePath": "tET-12.pptx",
  "includeCoverPage": "N",
  "includeContentPage": "N",
  "includeEndPage": "N",
  "pin": "N",
  "clientName": "Microsoft",
  "clientChartReportPages": [
    {
      "clientChartId": 1363,
      "name": "Pricing Power",
      "include": true
    },
    {
      "clientChartId": 1363,
      "name": "Metric Contribution",
      "include": true
    },
    {
      "clientChartId": 1363,
      "name": "Predictive Analytics",
      "sequenceNumber": 1,
      "include": false
    },
    {
      "clientChartId": 1363,
      "name": "Metric Trends",
      "sequenceNumber": 2,
      "include": false
    },
    {
      "clientChartId": 1363,
      "name": "Profile Trends",
      "sequenceNumber": 3,
      "include": false
    }
  ],
}

*/
    };
  },
  methods: {
   processDefaultWinnerMaps: function(){
      this.$root.processServerRequest("Processing default winner maps");
      WinnersService.processDefaultWinnerMaps(this.processDefaultWinnerMapsCallback,this);
   },
   processDefaultWinnerMapsCallback: function(response){
      this.$root.processServerResponse();
      let statusCode = response.data.statusCode;
      if (statusCode == 200) {
        this.$notify(AdminService.displaySuccessMessage({ text: response.data.message, duration: -1 }));
      } else {
        this.$notify(AdminService.displayErrorMessage({ text: response.data.message }));
      }
   },
   buildBenchmarkMappingCallback: function(response){
    this.$root.processServerResponse();
      let statusCode = response.data.statusCode;
      if (statusCode == 200) {
        this.$notify(AdminService.displaySuccessMessage({ text: response.data.message, duration: -1 }));
      } else {
        this.$notify(AdminService.displayErrorMessage({ text: response.data.message }));
      }
   },
   buildBenchmarkMapping: function(){
      this.$root.processServerRequest("Building Benchmark Mapping");
      BenchmarkCompanyService.buildBenchmarkMapping(this.buildBenchmarkMappingCallback,this);
   },
   executePrintReportToPPTX: async function(){
    await ReportService.generatePowerPointReport(this.clientReport, this.saveReport, this.downloadItemCallback, this);
   },
   getDownloadFilename() {
      let filename = this.clientReport.title;
      if (this.clientReport.subTitle != "") {
        filename += "-" + this.clientReport.subTitle;
      }
      filename += ".pptx";
      return filename;
    },   
   downloadItemCallback(response) {
      this.$root.processServerResponse();
      if (!this.saveReport){
        const blob = new Blob([response.data], { type: "application/pdf" });
        this.clickLink(blob);
        this.setModalLoading(false);
        this.$notify(AdminService.displaySuccessMessage({ text: "Download Complete", duration: 2000 }));
        this.reportGenerationModalContent = ReportService.getReportDownloadCompleteMessage();
      } else {
        this.$notify(AdminService.displaySuccessMessage({ text: "Report saved. Go to The W Report page to download", duration: 2000 }));
        this.reportGenerationModalContent = ReportService.getReportSavedCompleteMessage();
      }
      this.saveReport = false;
      this.printReportUrl = "";
    }, 
  },
  created() {},
  mounted() {
    this.inputClientCode = ClientService.getClientCode();
    this.setDisplayView(true);
  }
};
</script>
<style lang="scss">
</style>
